import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button, Input, Label } from "reactstrap";
import { updateUserOnboardingConfig } from "helpers/fakebackend_helper";

const RatesOfPayModal = ({ isOpen, toggle, user }) => {
    const config = user?.user_onboarding_config || {};
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");

    const [rateBy, setRateBy] = useState("Hour");
    const [ratesOfPay, setRatesOfPay] = useState("$18");
    const [overtimeRates, setOvertimeRates] = useState("Per California State");
    const [writtenAgreement, setWrittenAgreement] = useState("0");
    const [allRatesExist, setAllRatesExist] = useState("0");
    const [allowances, setAllowances] = useState("");
    const [regularPayday, setRegularPayday] = useState("On the 10th and 25th of each month.");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!isOpen) return;

        setRateBy(config.rate_by ?? "Hour");
        setRatesOfPay(config.rates_of_pay ?? "$18");
        setOvertimeRates(config.overtime_rates_of_pay ?? "Per California State");

        setWrittenAgreement(
            config.is_written_agreement_exist != null
                ? String(config.is_written_agreement_exist)
                : "0"
        );

        setAllRatesExist(
            config.are_all_rates_exist_in_written_agreement != null
                ? String(config.are_all_rates_exist_in_written_agreement)
                : "0"
        );

        setAllowances(config.allowances ?? "");
        setRegularPayday(config.regular_payday ?? "On the 10th and 25th of each month.");
    }, [isOpen, user]);

    const save = async () => {
        setError("");
        setLoading(true);

        const token = authUser?.token || "";

        const payload = {
            email: user.email,
            rates_of_pay: ratesOfPay,
            overtime_rates_of_pay: overtimeRates,
            rate_by: rateBy,
            is_written_agreement_exist: writtenAgreement,
            are_all_rates_exist_in_written_agreement:
                writtenAgreement === "1" ? allRatesExist : "0",
            allowances,
            regular_payday: regularPayday
        };

        const res = await updateUserOnboardingConfig(token, payload);
        setLoading(false);

        if (res.code !== 1) {
            setError(res.message || "Failed to update rates");
            return;
        }

        toggle();
    };

    // Reusable input container style
    const fieldWrap = {
        background: "#3a3a3a",
        padding: "14px 16px",
        borderRadius: 12,
        marginBottom: 18
    };

    const labelStyle = {
        color: "#ffd86b",
        fontWeight: 700,
        marginBottom: 6,
        fontSize: 14
    };

    const inputStyle = {
        background: "#2b2b2b",
        border: "1px solid rgba(255,255,255,0.1)",
        color: "white",
        borderRadius: 10
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            contentClassName="custom-dark-modal"
            style={{ maxWidth: 500 }}
        >
            <ModalBody
                style={{
                    background: "#262523",
                    padding: 30,
                    borderRadius: 12,
                    color: "white"
                }}
            >
                <div
                    style={{
                        fontSize: 22,
                        color: "#ffd86b",
                        fontWeight: 800,
                        textAlign: "center",
                        marginBottom: 20
                    }}
                >
                    Update Rates of Pay
                </div>

                {error && (
                    <div
                        style={{
                            background: "#a33",
                            padding: "10px 14px",
                            borderRadius: 10,
                            marginBottom: 12,
                            fontWeight: 600
                        }}
                    >
                        {error}
                    </div>
                )}

                {/* Rate By (disabled) */}
                <div style={fieldWrap}>
                    <Label style={labelStyle}>Rate By</Label>
                    <Input value={rateBy} disabled style={inputStyle} />
                </div>

                {/* Rates of Pay */}
                <div style={fieldWrap}>
                    <Label style={labelStyle}>Rates of Pay</Label>
                    <Input
                        value={ratesOfPay}
                        onChange={(e) => setRatesOfPay(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                {/* Overtime Rates */}
                <div style={fieldWrap}>
                    <Label style={labelStyle}>Overtime Rates of Pay</Label>
                    <Input
                        value={overtimeRates}
                        onChange={(e) => setOvertimeRates(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                {/* Written Agreement */}
                <div style={fieldWrap}>
                    <Label style={labelStyle}>Is written agreement exist?</Label>

                    <div style={{ display: "flex", gap: 14, marginTop: 10 }}>
                        {[
                            { label: "Yes", value: "1" },
                            { label: "No", value: "0" }
                        ].map(opt => {
                            const active = writtenAgreement === opt.value;

                            return (
                                <div
                                    key={opt.value}
                                    onClick={() => setWrittenAgreement(opt.value)}
                                    style={{
                                        padding: "10px 18px",
                                        borderRadius: 10,
                                        cursor: "pointer",
                                        background: active ? "#ffd86b" : "#3a3a3a",
                                        color: active ? "#000" : "#ccc",
                                        fontWeight: 700,
                                        border: active
                                            ? "1px solid #ffecb3"
                                            : "1px solid rgba(255,255,255,0.1)",
                                        transition: "0.2s",
                                        userSelect: "none"
                                    }}
                                >
                                    {opt.label}
                                </div>
                            );
                        })}
                    </div>
                </div>


                {/* All rates exist */}
                {writtenAgreement === "1" && (
                    <div style={fieldWrap}>
                        <Label style={labelStyle}>Are all rates exist in written agreement?</Label>

                        <div style={{ display: "flex", gap: 14, marginTop: 10 }}>
                            {[
                                { label: "Yes", value: "1" },
                                { label: "No", value: "0" }
                            ].map(opt => {
                                const active = allRatesExist === opt.value;

                                return (
                                    <div
                                        key={opt.value}
                                        onClick={() => setAllRatesExist(opt.value)}
                                        style={{
                                            padding: "10px 18px",
                                            borderRadius: 10,
                                            cursor: "pointer",
                                            background: active ? "#ffd86b" : "#3a3a3a",
                                            color: active ? "#000" : "#ccc",
                                            fontWeight: 700,
                                            border: active
                                                ? "1px solid #ffecb3"
                                                : "1px solid rgba(255,255,255,0.1)",
                                            transition: "0.2s",
                                            userSelect: "none"
                                        }}
                                    >
                                        {opt.label}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Allowances */}
                <div style={fieldWrap}>
                    <Label style={labelStyle}>Allowances</Label>
                    <Input
                        placeholder="Optional"
                        value={allowances}
                        onChange={(e) => setAllowances(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                {/* Payday */}
                <div style={fieldWrap}>
                    <Label style={labelStyle}>Regular Payday</Label>
                    <Input
                        value={regularPayday}
                        onChange={(e) => setRegularPayday(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                {/* Buttons */}
                <div
                    style={{
                        marginTop: 25,
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    <Button
                        onClick={toggle}
                        style={{
                            background: "#444",
                            border: "none",
                            padding: "10px 24px",
                            borderRadius: 10,
                            fontWeight: 700
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={save}
                        disabled={loading}
                        style={{
                            background: "#ffd86b",
                            color: "#000",
                            border: "none",
                            padding: "10px 24px",
                            borderRadius: 10,
                            fontWeight: 700,
                            minWidth: 120
                        }}
                    >
                        {loading ? "Saving..." : "Save"}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default RatesOfPayModal;